export enum NotificationType {
    Toast = 1,
    SweetAlert = 2
  }  